import { useValidationMessageTranslationsT } from "src/translation-hooks/validation-message-translations";

export const projectNameValidation = (t: ReturnType<typeof useValidationMessageTranslationsT>) => (value: string | null | undefined) => {
  if (value && !/^[A-Za-z]/.test(value)) return t.mustStartWithAlphabet;
  if (value && value?.length < 5) return t.mustBe5CharactersLong;
  if (value && value?.length > 200) return t.mustBeLessThanCharacters("200");
};
